import { render, staticRenderFns } from "./TaxonomyCodeMultiselect.vue?vue&type=template&id=5f2242b1&scoped=true&"
import script from "./TaxonomyCodeMultiselect.vue?vue&type=script&lang=js&"
export * from "./TaxonomyCodeMultiselect.vue?vue&type=script&lang=js&"
import style0 from "./TaxonomyCodeMultiselect.vue?vue&type=style&index=0&id=5f2242b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2242b1",
  null
  
)

export default component.exports